module.exports = __webpack_public_path__ + "d22c6312d2227358cefb92e021fc0b63.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/year-in-review/2018/midyear/afi/white.png
// module id = 637
// module chunks = 1